import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';

// Базовый путь берём из билда: PUBLIC_URL='/2fa' (портал по пути) или '' (поддомен в корне).
const ROUTER_BASE_PATH = process.env.PUBLIC_URL || '';

function normalizeDirectPortPath(): void {
  // В корневом развёртывании (поддомен) ничего не нормализуем.
  if (!ROUTER_BASE_PATH) {
    return;
  }

  const { pathname, search, hash } = window.location;

  if (pathname === ROUTER_BASE_PATH || pathname.startsWith(`${ROUTER_BASE_PATH}/`)) {
    return;
  }

  if (pathname.startsWith('/api/') || pathname === '/health') {
    return;
  }

  if (/\.[a-z0-9]+$/i.test(pathname)) {
    return;
  }

  const normalizedPath = pathname === '/'
    ? ROUTER_BASE_PATH
    : `${ROUTER_BASE_PATH}${pathname}`;

  window.history.replaceState(null, '', `${normalizedPath}${search}${hash}`);
}

normalizeDirectPortPath();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename={ROUTER_BASE_PATH || '/'}>
      <Routes>
        <Route path="/:seed?" element={<App />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
